import type { FlowStepInput } from '@/data'

export type FormFieldName =
  | 'name'
  | 'email'
  | 'phone'
  | 'state'
  | 'birthdate'
  | 'address'

export const requiredFormFieldIds: FormFieldName[] = ['name', 'email', 'phone']

export const availableFormInputs: FlowStepInput[] = [
  {
    id: 'name',
    label: 'Name',
    type: 'text',
    placeholder: null,
    required: true,
  },
  {
    id: 'email',
    label: 'Email',
    type: 'email',
    placeholder: null,
    required: true,
  },
  {
    id: 'phone',
    label: 'Phone',
    type: 'phone',
    placeholder: null,
    required: true,
  },
  {
    id: 'state',
    label: 'State',
    type: 'select',
    placeholder: null,
    required: false,
  },
  {
    id: 'birthdate',
    label: 'Date of Birth',
    type: 'text',
    placeholder: null,
    required: false,
  },
  {
    id: 'address',
    label: 'Address',
    type: 'text',
    placeholder: null,
    required: false,
  },
]
